import {Map} from "@luciad/ria/view/Map";
import React, {useState} from "react";
import {LocationSuggestion, suggestionToFitBounds, useHEREAutoComplete} from "../../hooks/useHEREAutoComplete";
import {useHereMapsAPIKeyFromLocalStorage} from "../../hooks/useHereMapsAPIKey";
import {AutoCompleteInput} from "../AutoCompleteInput";
import {HereMapsAPIKeyPrompt} from "../HereMapsAPIPrompt";
import {Modal} from "../Modal";
import "./HereSearchBar.css";

const DEFAULT_SUGGESTION_SECTIONS = [
  {
    id: "",
    header: null,
    suggestions: [{id: "", label: "CONFIGURE HERE MAPS KEY", value: null}],
  },
];

interface Props {
  map: Map;
}

/**
 * Component that allows users to search for places and then fits on selected locations.
 * It uses the HERE geocoding API (https://developer.here.com/documentation/geocoding-search-api/api-reference-swagger.html)
 * to map free-text queries to locations.
 */
export const HereSearchBar = ({map}: Props) => {
  const [text, setText] = useState<string>("");
  const {apiKey, setApiKey, validationState, validationFeedback} = useHereMapsAPIKeyFromLocalStorage();
  const [modalOpen, setModalOpen] = useState(false);
  const suggestions = useHEREAutoComplete(text, apiKey);

  /**
   * Fits on the bounds of the given suggestion.
   * If the suggestion  only contains point data, bounds around that point are constructed with a default radius.
   */
  function handleGoTo(suggestion: LocationSuggestion | null) {
    if (!suggestion) {
      if (!apiKey) {
        setText("");
        setModalOpen(true);
      }
      return;
    } else {
      const bounds = suggestionToFitBounds(suggestion);
      map.mapNavigator.fit({bounds, animate: true,});
    }
  }

  return (
      <>
        <AutoCompleteInput<LocationSuggestion | null>
            text={text}
            onTextChange={setText}
            onChange={handleGoTo}
            suggestionSections={apiKey ? suggestions : DEFAULT_SUGGESTION_SECTIONS}
            className="here-search-bar"
            placeHolder="Search for a place"
            placeHolderIconClass="lcd-icon-search"
        />
        <Modal
            show={modalOpen}
            title={"Configure HERE key"}
            onHide={() => setModalOpen(false)}
            position="top"
        >
          <HereMapsAPIKeyPrompt value={apiKey} onChange={setApiKey} validationState={validationState}
                                validationFeedback={validationFeedback}/>
        </Modal>
      </>
  );
};